import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const TestStatistics = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData =
    labels.menuPages?.sellCar?.testSection?.testStatistics || {};
  const statsData = sectionData.stats || [];

  const colors = ["text-blue-600", "text-green-600", "text-purple-600"];

  return (
    <div className="mt-16 text-center bg-gray-50 rounded-3xl p-12">
      <h3 className="text-3xl font-bold text-gray-900 mb-8">
        {sectionData.title || "Varför Är Testet Så Viktigt?"}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {statsData.map((stat: any, index: number) => (
          <div key={index} className="text-center">
            <div
              className={`text-4xl font-bold ${colors[index] || colors[0]} mb-4`}
            >
              {stat.value || ""}
            </div>
            <div className="text-lg font-semibold text-gray-900 mb-2">
              {stat.label || ""}
            </div>
            <div className="text-gray-600">{stat.description || ""}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestStatistics;
